import React from "react";
import {
  PageCreatorSectionModel,
  PageCreatorSectionType,
} from "../Models/PageCreatorPage";
import CardCarousel from "./CardCarousel";
import FourWideImage from "./FourWideImage";
import EventHero from "./EventHero";
import ImageLeftCarousel from "./ImageLeftCarousel";
import NavBar from "./NavBar";
import ImageNavBar from "./ImageNavBar";
import StandardCarousel from "./StandardCarousel";
import TwoWideImage from "./TwoWideImage";
import OneWideImage from "./OneWideImage";
import FlashDeal from "./FlashDeal";

export interface GroupSectionProps {
  section: PageCreatorSectionModel;
  couponCode: string;
  activeStartDate: string;
  activeEndDate: string;
  isItemListingPage: boolean;
  isHeaderGroup?: boolean;
}

const GroupSection = ({
  section,
  couponCode,
  activeStartDate,
  activeEndDate,
  isItemListingPage,
  isHeaderGroup,
}: GroupSectionProps) => {
  switch (section.sectionType) {
    case PageCreatorSectionType.EventHero:
      return (
        <EventHero
          {...section.eventHero}
          activeStartDate={activeStartDate}
          activeEndDate={activeEndDate}
          isItemListingPage={isItemListingPage}
        />
      );
    case PageCreatorSectionType.OneWideImage:
      return <OneWideImage images={section.wideImages} />;
    case PageCreatorSectionType.TwoWideImage:
      return <TwoWideImage images={section.wideImages} />;
    case PageCreatorSectionType.FourWideImage:
      return <FourWideImage images={section.wideImages} />;
    case PageCreatorSectionType.ImageLeftCarousel:
      return (
        <ImageLeftCarousel
          {...section.imageLeftCarousel}
          couponCode={couponCode}
        />
      );
    case PageCreatorSectionType.CardCarousel:
      return <CardCarousel {...section.cardCarousel} couponCode={couponCode} />;
    case PageCreatorSectionType.NavBar:
      if (!isItemListingPage && !section.navBar.enableCustomNavigationLinks) {
        return <ImageNavBar {...section.navBar} />;
      }
      return <NavBar {...section.navBar} />;
    case PageCreatorSectionType.StandardCarousel:
      return (
        <StandardCarousel
          {...section.standardCarousel}
          couponCode={couponCode}
        />
      );
    case PageCreatorSectionType.FlashDeal:
      if (!isItemListingPage && section.flashDeal?.items.length > 0) {
        return (
          <FlashDeal
            {...section.flashDeal}
            couponCode={couponCode}
            isHeaderGroup={isHeaderGroup}
          />
        );
      }
      return <></>;
    default:
      return <></>;
  }
};

export default GroupSection;
